var zevia = { 
    captch: function() {
        $('.fake-recaptcha').click(function () {
            var box = $(this);
            if (box.hasClass('checked')) return;
            box.addClass('loading');
            var id = parseInt($(this).closest('.cpth_item').data('id')) + 1;
            setTimeout(function () {
                box.removeClass('loading');
                box.addClass('checked');
                
            }, 1500);  
            setTimeout(function () {
                //show_next(id);
                window.location.href = "/pages/zero-artificial-100-real-human";
            }, 2500);
        });

        function show_next(step){
            $('.cpth_item').hide();
            $('.cpth_item[data-id="'+step+'"]').show();
            if(step == '3'){
                //last_option();
            }
        }

        function last_option(){ 
            setTimeout(function () { 
                window.location.href = "/pages/zero-artificial-100-real-human";
            }, 1000);
        }

        $('body').on('click', '.cpthmg_img', function(){
            $(this).closest('.cpthmg_listing').find('.cpthmg_img').removeClass('active');
            $(this).addClass('active');

            if($(this).hasClass('cpthmg_select')){
                $(this).closest('.cpthmg_box').find('.cpthmgf_verfy').addClass('active');
            }else{
                $(this).closest('.cpthmg_box').find('.cpthmgf_verfy').removeClass('active');
            }
        });
 
        $('.cpthmgf_verfy').on('click', function(){
            if($(this).hasClass('active')){
                if($(this).hasClass('cpthmgf_redirect')){
                    last_option();
                }else{
                    var id = parseInt($(this).closest('.cpth_item').data('id')) + 1;
                    show_next(id);
                }               
            }
        });


        $('.cpthmgf_img').on('click', function(){ 
                var id = get_random(1, max_number);
                $('.cpthmg_box, .cpthmg_img').removeClass('active');
                $('.cpthmg_box[data-id="'+id+'"]').addClass('active'); 
                getRandomArray();
        });

        function get_random(min, max){
            return Math.floor(Math.random() * (max - min + 1)) + min;
        }

        $('.sctseml_btn_style').on('click', function(){
            var email = $('.sctseml_email_style').val();
            if(checkEmail(email)){
               var step = parseInt($(this).closest('.cpth_item').data('id')) + 1;
               var name = $('.cpfr_name').val(); 
               var zip_cide = $('.cpfr_zipcode').val(); 
               var state = $('.cpfr_state').val(); 
               if(name != '' && zip_cide != '' && state != ''){
                zevia.add_email_google(email, name, zip_cide, state);
                show_next(step);
               }
                
            }else{
 
            }
        });

        function checkEmail(email){
            var pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return pattern.test(email);
        } 

        function getRandomArray() {
            var numbers = [0,1,2,3,4,5,6,7,8];
            for (var i = numbers.length - 1; i > 0; i--) {
                var j = Math.floor(Math.random() * (i + 1));
                [numbers[i], numbers[j]] = [numbers[j], numbers[i]];
            }
            $('.cpthmg_box.active .cpthmg_listing .cpthmg_img').each(function(index){
                this.style.order = numbers[index];
            });
        }
        
        getRandomArray();           
    },
    add_email_google(email, name, zip_cide, state){  
        console.log(name);
        console.log(zip_cide);
        console.log(state);
        $.ajax({
            url: "https://script.google.com/macros/s/AKfycbzEVrvxqfb7esvHDqTPAYu059cGjM2E7suGixU-fGT-o-sLocbo6Rj-5c2noDPG_465QA/exec",
            type: "POST",
            data: {
                name: name,
                zipcode: zip_cide,
                state: state,
                email: email
            },
            success: function(res){
                //return true;
               // alert("Email Saved"); 
            }
        });  
    }
}

$(function(){
    zevia.captch();
});